/** Unique keys for "pacs" module's DTOs */
export enum PacsDtoKeysEnum {
  /** Access card list APIs base filters */
  ACCESS_CARD_FILTERS_DTO = 'pacs/access-card-filters.dto',
  /** Access card response body */
  ACCESS_CARD_FIND_DTO = 'pacs/access-card-find.dto',
  /** Access card create/update request body */
  ACCESS_CARD_FORM_DTO = 'pacs/access-card-form.dto',
  /** Access card partial update request body */
  ACCESS_CARD_PARTIAL_FORM_DTO = 'pacs/access-card-partial-form.dto',
  /** Access cards list with pagination API response body */
  ACCESS_CARD_PAGE_DTO = 'pacs/access-card-page.dto',
  /** Access cards list with pagination API query parameters */
  ACCESS_CARD_QUERY_DTO = 'pacs/access-card-query.dto',
  /** Access card control report common filters */
  ACCESS_CARD_CONTROL_REPORT_FILTERS_DTO = 'pacs/access-card-control-report-filters.dto',
  /** Access card control report registry API response body item */
  ACCESS_CARD_CONTROL_REPORT_REGISTRY_ITEM_DTO = 'pacs/access-card-control-report-registry-item.dto',
  /** Access card control report registry API query parameters */
  ACCESS_CARD_CONTROL_REPORT_REGISTRY_QUERY_DTO = 'pacs/access-card-control-report-registry-query.dto',
  /** Access card control report statistics API response body item */
  ACCESS_CARD_CONTROL_REPORT_STAT_ITEM_DTO = 'pacs/access-card-control-report-stat-item.dto',
  /** Access card control report statistics API query parameters */
  ACCESS_CARD_CONTROL_REPORT_STAT_QUERY_DTO = 'pacs/access-card-control-report-stat-query.dto',
  /** Access card control report subtotal API response body */
  ACCESS_CARD_CONTROL_REPORT_SUBTOTAL_DTO = 'pacs/access-card-control-report-subtotal.dto',
  /** Access card control report registry page API response body */
  ACCESS_CARD_CONTROL_REPORT_REGISTRY_PAGE_DTO = 'pacs/access-card-control-report-registry-page.dto',
  /** Access card control report registry selectable item */
  ACCESS_CARD_CONTROL_REPORT_REGISTRY_SELECTABLE_ITEM_DTO = 'pacs/access-card-control-report-registry-selectable-item.dto',
  /** Access card control report registry drill */
  ACCESS_CARD_CONTROL_REPORT_REGISTRY_DRILL_DTO = 'pacs/access-card-control-report-registry-drill.dto',
  /** Access card control report select */
  ACCESS_CARD_CONTROL_REPORT_SELECT_DTO = 'pacs/access-card-control-report-select.dto',
  /** Access card control report subtotal grouping */
  ACCESS_CARD_CONTROL_REPORT_SUBTOTAL_BY_DTO = 'pacs/access-card-control-report-subtotal-by.dto',
  /** Access card control report subtotal sorting */
  ACCESS_CARD_CONTROL_REPORT_STAT_SORT_DTO = 'pacs/access-card-control-report-stat-sort.dto',
  /** Access card control report registry sorting */
  ACCESS_CARD_CONTROL_REPORT_REGISTRY_SORT_DTO = 'pacs/access-card-control-report-registry-sort.dto',
  /** Coming/Going report internal/external user calendar entry */
  COMING_GOING_REPORT_CALENDAR_ENTRY_DTO = 'pacs/coming-going-report-calendar-entry.dto',
  /** Coming/Going report base filters */
  COMING_GOING_REPORT_FILTERS_DTO = 'pacs/coming-going-report-filters.dto',
  /** Coming/Going report item */
  COMING_GOING_REPORT_ITEM_DTO = 'pacs/coming-going-report-item.dto',
  /** Coming/Going report page response body */
  COMING_GOING_REPORT_PAGE_DTO = 'pacs/coming-going-report-page.dto',
  /** Coming/Going report query parameters */
  COMING_GOING_REPORT_QUERY_DTO = 'pacs/coming-going-report-query.dto',
  /** Coming/Going report registry page API response body */
  COMING_GOING_REPORT_ITEMS_PAGE_DTO = 'pacs/coming-going-report-items-page.dto',
  /** Coming/Going report registry static selectable columns */
  COMING_GOING_REPORT_REGISTRY_SELECTABLE_ITEM_DTO = 'pacs/coming-going-report-registry-selectable-item.dto',
  /** Coming/Going report column selection settings */
  COMING_GOING_REPORT_SELECT_DTO = 'pacs/coming-going-report-select.dto',
  /** Base converters list APIs filters */
  CONVERTER_FILTERS_DTO = 'pacs/converter-filters.dto',
  /** Converter response body */
  CONVERTER_FIND_DTO = 'pacs/converter-find.dto',
  /** Converter create/update request body */
  CONVERTER_FORM_DTO = 'pacs/converter-form.dto',
  /** Converter card update request body */
  CONVERTER_CARD_FORM_DTO = 'pacs/converter-card-form.dto',
  /** Converter change password request body */
  CONVERTER_CHANGE_PASSWORD_DTO = 'pacs/converter-change-password.dto',
  /** Converter create request body */
  CONVERTER_CREATE_DTO = 'pacs/converter-create.dto',
  /** "Iron Logic" converter settings response body */
  CONVERTER_ICON_LOGIC_FIND_DTO = 'pacs/converter-icon-logic-find.dto',
  /** Converter events invertion settings */
  CONVERTER_INVERT_EVENTS_DTO = 'pacs/converter-invert-events.dto',
  /** Converter list with pagination API response body */
  CONVERTER_PAGE_DTO = 'pacs/converter-page.dto',
  /** Converter registry selectable item */
  CONVERTER_REGISTRY_SELECTABLE_ITEM_DTO = 'pacs/converter-registry-selectable-item.dto',
  /** Converter registry page API response body */
  CONVERTER_REPORT_ITEMS_PAGE_DTO = 'pacs/converter-report-items-page.dto',
  /** Converter ping settings */
  CONVERTER_PING_SETTINGS_DTO = 'pacs/converter-ping-settings.dto',
  /** Converter list API query parameters */
  CONVERTER_QUERY_DTO = 'pacs/converter-query.dto',
  /** Converter selection settings */
  CONVERTER_SELECT_DTO = 'pacs/converter-select.dto',
  /** Converter cards reading settings response body */
  CONVERTER_READ_CARDS_FIND_DTO = 'pacs/converter-read-cards-find.dto',
  /** Converter cards reading settings create/update request body */
  CONVERTER_READ_CARDS_FORM_DTO = 'pacs/converter-read-cards-form.dto',
  /** Test mock converter settings response body */
  CONVERTER_TEST_MOCK_FIND_DTO = 'pacs/converter-test-mock-find.dto',
  /** User access converter request body */
  CONVERTER_ACCESS_PARAM_DTO = 'pacs/converter-access-param.dto',
  /** Group access converter request body */
  CONVERTER_ACCESS_GROUP_PARAM_DTO = 'pacs/converter-access-group-param.dto',
  /** Converter time zone body */
  CONVERTER_TIMEZONE_FIND_DTO = 'pacs/converter-timezone-find.dto',
  /** Converter reset time zone query parameters */
  CONVERTER_TIMEZONE_QUERY_DTO = 'pacs/converter-timezone-query.dto',
  /** Converter set timezone request body */
  CONVERTER_TIMEZONE_FORM_DTO = 'pacs/converter-timezone-form.dto',
  /** Converter single timezone request body */
  CONVERTER_TIMEZONE_SINGLE_FORM_DTO = 'pacs/converter-timezone-single-form.dto',
  /** Send command to "Iron Logic" converter API request body */
  IRON_LOGIC_COMMAND_FORM_DTO = 'pacs/iron-logic-command-form.dto',
  /** Response body of queued command from "FRM" to "Iron Logic" */
  IRON_LOGIC_COMMAND_QUEUE_FIND_DTO = 'pacs/iron-logic-command-queue-find.dto',
  /** "Iron Logic" devices queued commands page response body */
  IRON_LOGIC_COMMAND_QUEUE_PAGE_DTO = 'pacs/iron-logic-command-queue-page.dto',
  /** "Iron Logic" devices queued commands page API query parameters */
  IRON_LOGIC_COMMAND_QUEUE_QUERY_DTO = 'pacs/iron-logic-command-queue-query.dto',
  /** "Iron Logic" devices repeat commands API query parameters */
  IRON_LOGIC_COMMAND_REPEAT_EXPIRED_QUERY_DTO = 'pacs/iron-logic-command-repeat-expired-query.dto',
  /** "Iron Logic" devices incoming messages history log delete query parameters */
  IRON_LOGIC_MESSAGES_LOG_DELETE_DTO = 'pacs/iron-logic-messages-log-delete.dto',
  /** "Iron Logic" devices incoming messages history entry response body */
  IRON_LOGIC_MESSAGES_LOG_FIND_DTO = 'pacs/iron-logic-messages-log-find.dto',
  /** "Iron Logic" devices incoming messages history entries slice response body */
  IRON_LOGIC_MESSAGES_LOG_PAGE_DTO = 'pacs/iron-logic-messages-log-page.dto',
  /** "Iron Logic" devices incoming messages history entries filters and settings */
  IRON_LOGIC_MESSAGES_LOG_QUERY_DTO = 'pacs/iron-logic-messages-log-query.dto',
  /** Logging events report API request body */
  EQUIPMENT_LOG_FORM_DTO = 'pacs/equipment-log-form.dto',
  /** Logging events report API responce body */
  EQUIPMENT_LOG_FIND_DTO = 'pacs/equipment-log-find.dto',
  /** Logging events report list with pagination API response body */
  EQUIPMENT_LOG_PAGE_DTO = 'pacs/equipment-log-page.dto',
  /** Logging events report list API query parameters */
  EQUIPMENT_LOG_QUERY_DTO = 'pacs/equipment-log-query.dto',
  /** Logging events report list APIs filters */
  EQUIPMENT_LOG_FILTERS_DTO = 'pacs/equipment-log-filters.dto',
  /** Equipment event report registry selectable item */
  EQUIPMENT_EVENT_REPORT_REGISTRY_SELECTABLE_ITEM_DTO = 'pacs/equipment-event-report-registry-selectable-item.dto',
  /** Equipment event report selection settings */
  EQUIPMENT_EVENT_REPORT_SELECT_DTO = 'pacs/equipment-event-report-select.dto',
  /** Equipment event report registry page API response body */
  EQUIPMENT_LOG_REPORT_ITEMS_PAGE_DTO = 'pacs/equipment-log-report-items-page.dto',
  /** Logging photo-verification report list API query parameters */
  EQUIPMENT_LOG_PHOTO_VERIFICATION_QUERY_DTO = 'pacs/equipment-log-photo-verification-query.dto',
  /** Logging photo-verification report list with pagination API response body */
  EQUIPMENT_LOG_PAGE_PHOTO_VERIFICATION_DTO = 'pacs/equipment-log-page-photo-verification.dto',
  /** Logging photo-verification report list with pagination API response body */
  EQUIPMENT_LOG_FIND_PHOTO_VERIFICATION_DTO = 'pacs/equipment-log-find-photo-verification.dto',
  /** Logging photo-verification report list APIs filters */
  EQUIPMENT_LOG_PHOTO_VERIFICATION_FILTERS_DTO = 'pacs/equipment-log-photo-verification-filters.dto',
  /** Logging photo-verification report sorting settings */
  EQUIPMENT_LOG_PHOTO_VERIFICATION_SORT_DTO = 'pacs/equipment-log-photo-verification-sort.dto',
  /** Photo verification report registry selectable item */
  PHOTO_VERIFICATION_REPORT_REGISTRY_SELECTABLE_ITEM_DTO = 'pacs/photo-verification-report-registry-selectable-item.dto',
  /** Photo verification report selection settings */
  PHOTO_VERIFICATION_REPORT_SELECT_DTO = 'pacs/photo-verification-report-select.dto',
  /** Photo verification report registry page API response body */
  EQUIPMENT_LOG_PHOTO_VERIFICATION_REPORT_ITEMS_PAGE_DTO = 'pacs/equipment-log-photo-verification-report-items-page.dto',
  /** "NetPing" device barrier status API response body */
  NET_PING_DEVICE_BARRIER_STATUS_DTO = 'pacs/net-ping-device-barrier-status.dto',
  /** "NetPing" find many API own filters */
  NET_PING_DEVICE_FILTERS_DTO = 'pacs/net-ping-device-filters.dto',
  /** "NetPing" find many API query parameters */
  NET_PING_DEVICE_FIND_MANY_QUERY_DTO = 'pacs/net-ping-device-find-many-query.dto',
  /** "NetPing" device find one API query parameters */
  NET_PING_DEVICE_FIND_ONE_QUERY_DTO = 'pacs/net-ping-device-find-one-query.dto',
  /** "NetPing" device selection settings */
  NET_PING_DEVICE_SELECT_DTO = 'pacs/net-ping-device-select.dto',
  /** "NetPing" device response body */
  NET_PING_DEVICE_FIND_DTO = 'pacs/net-ping-device-find.dto',
  /** "NetPing" device create and update APIs request body */
  NET_PING_DEVICE_FORM_DTO = 'pacs/net-ping-device-form.dto',
  /** "NetPing" find many API response body */
  NET_PING_DEVICE_PAGE_DTO = 'pacs/net-ping-device-page.dto',
  /** "NetPing" registry items page API response body */
  NET_PING_DEVICE_REPORT_ITEMS_PAGE_DTO = 'pacs/net-ping-device-report-items-page.dto',
  /** Passage task create API request body */
  PASSAGE_TASK_CREATE_DTO = 'pacs/passage-task-create.dto',
  /** Passage task own filters */
  PASSAGE_TASK_FILTERS_DTO = 'pacs/passage-task-filters.dto',
  /** Passage task find many API query parameters */
  PASSAGE_TASK_FIND_MANY_QUERY_DTO = 'pacs/passage-task-find-many-query.dto',
  /** Passage task find one API query parameters */
  PASSAGE_TASK_FIND_ONE_QUERY_DTO = 'pacs/passage-task-find-one-query.dto',
  /** Passage task response body */
  PASSAGE_TASK_FIND_DTO = 'pacs/passage-task-find.dto',
  /** Passage task update API request body */
  PASSAGE_TASK_FORM_DTO = 'pacs/passage-task-form.dto',
  /** Passage task find many API response body */
  PASSAGE_TASK_PAGE_DTO = 'pacs/passage-task-page.dto',
  /** Passage task partial update API request body */
  PASSAGE_TASK_PARTIAL_FORM_DTO = 'pacs/passage-task-partial-form.dto',
  /** Passage task tenant registry page API response body */
  PASSAGE_TASK_REPORT_ITEMS_PAGE_DTO = 'pacs/passage-task-report-items-page.dto',
  /** Passage task tenant registry selectable item */
  PASSAGE_TASK_REGISTRY_SELECTABLE_ITEM_DTO = 'pacs/passage-task-registry-selectable-item.dto',
  /** Passage task selection settings */
  PASSAGE_TASK_SELECT_DTO = 'pacs/passage-task-select.dto',
  /** Passage task sorting settings */
  PASSAGE_TASK_SORT_DTO = 'pacs/passage-task-sort.dto',
  /** Passage task switch status API request body */
  PASSAGE_TASK_SWITCH_STATUS_DTO = 'pacs/passage-task-switch-status.dto',
  /** Passage task create API request body for personal account mode */
  PASSAGE_TASK_LK_CREATE_DTO = 'pacs/passage-task-lk-create.dto',
  /** Passage task own filters for personal account mode */
  PASSAGE_TASK_LK_FILTERS_DTO = 'pacs/passage-task-lk-filters.dto',
  /** Passage task find many API query parameters for personal account mode */
  PASSAGE_TASK_LK_FIND_MANY_QUERY_DTO = 'pacs/passage-task-lk-find-many-query.dto',
  /** Passage task find one API query parameters for personal account mode */
  PASSAGE_TASK_LK_FIND_ONE_QUERY_DTO = 'pacs/passage-task-lk-find-one-query.dto',
  /** Passage task response body for personal account mode */
  PASSAGE_TASK_LK_FIND_DTO = 'pacs/passage-task-lk-find.dto',
  /** Passage task update API request body for personal account mode */
  PASSAGE_TASK_LK_FORM_DTO = 'pacs/passage-task-lk-form.dto',
  /** Passage task find many API response body for personal account mode */
  PASSAGE_TASK_LK_PAGE_DTO = 'pacs/passage-task-lk-page.dto',
  /** Passage task partial update API request body for personal account mode */
  PASSAGE_TASK_LK_PARTIAL_FORM_DTO = 'pacs/passage-task-lk-partial-form.dto',
  /** Passage task selection settings for personal account mode */
  PASSAGE_TASK_LK_SELECT_DTO = 'pacs/passage-task-lk-select.dto',
  /** Passage task sorting settings for personal account mode */
  PASSAGE_TASK_LK_SORT_DTO = 'pacs/passage-task-lk-sort.dto',
  /** Personal-account passage task card descriptor API query */
  PASSAGE_TASK_LK_PERSONAL_ACCOUNT_CARD_DESCRIPTOR_QUERY_DTO = 'pacs/passage-task-lk-personal-account-card-descriptor-query.dto',
  /** Passage order response body */
  PASSAGE_ORDER_FIND_DTO = 'pacs/passage-order-find.dto',
  /** Passage order create/update API request body */
  PASSAGE_ORDER_FORM_DTO = 'pacs/passage-order-form.dto',
  /** Passage order partial update API request body */
  PASSAGE_ORDER_PARTIAL_FORM_DTO = 'pacs/passage-order-partial-form.dto',
  /** Passage order own filters */
  PASSAGE_ORDER_FILTERS_DTO = 'pacs/passage-order-filters.dto',
  /** Passage order find many API query parameters */
  PASSAGE_ORDER_FIND_MANY_QUERY_DTO = 'pacs/passage-order-find-many-query.dto',
  /** Passage order find one API query parameters */
  PASSAGE_ORDER_FIND_ONE_QUERY_DTO = 'pacs/passage-order-find-one-query.dto',
  /** Passage order find many API response body */
  PASSAGE_ORDER_PAGE_DTO = 'pacs/passage-order-page.dto',
  /** Passage order selection settings */
  PASSAGE_ORDER_SELECT_DTO = 'pacs/passage-order-select.dto',
  /** Passage order sorting settings */
  PASSAGE_ORDER_SORT_DTO = 'pacs/passage-order-sort.dto',
  /** Passage order switch status API request body */
  PASSAGE_ORDER_SWITCH_STATUS_DTO = 'pacs/passage-order-switch-status.dto',
  /** Passage order own filters for personal account mode */
  PASSAGE_ORDER_LK_FILTERS_DTO = 'pacs/passage-order-lk-filters.dto',
  /** Passage order find many API query parameters for personal account mode */
  PASSAGE_ORDER_LK_FIND_MANY_QUERY_DTO = 'pacs/passage-order-lk-find-many-query.dto',
  /** Passage order find one API query parameters for personal account mode */
  PASSAGE_ORDER_LK_FIND_ONE_QUERY_DTO = 'pacs/passage-order-lk-find-one-query.dto',
  /** Passage order response body for personal account mode */
  PASSAGE_ORDER_LK_FIND_DTO = 'pacs/passage-order-lk-find.dto',
  /** Passage order update API request body for personal account mode */
  PASSAGE_ORDER_LK_FORM_DTO = 'pacs/passage-order-lk-form.dto',
  /** Passage order create API request body for personal account mode */
  PASSAGE_ORDER_LK_CREATE_DTO = 'pacs/passage-order-lk-create.dto',
  /** Passage order find many API response body for personal account mode */
  PASSAGE_ORDER_LK_PAGE_DTO = 'pacs/passage-order-lk-page.dto',
  /** Passage order partial update API request body for personal account mode */
  PASSAGE_ORDER_LK_PARTIAL_FORM_DTO = 'pacs/passage-order-lk-partial-form.dto',
  /** Passage order selection settings for personal account mode */
  PASSAGE_ORDER_LK_SELECT_DTO = 'pacs/passage-order-lk-select.dto',
  /** Passage order sorting settings for personal account mode */
  PASSAGE_ORDER_LK_SORT_DTO = 'pacs/passage-order-lk-sort.dto',
  /** Personal-account passage order card descriptor API query parameters */
  PASSAGE_ORDER_LK_PERSONAL_ACCOUNT_CARD_DESCRIPTOR_QUERY_DTO = 'pacs/passage-order-lk-personal-account-card-descriptor-query.dto',
  /** Passage order employee response body */
  PASSAGE_ORDER_EMPLOYEE_FIND_DTO = 'pacs/passage-order-employee-find.dto',
  /** Passage order employee create/update API request body */
  PASSAGE_ORDER_EMPLOYEE_FORM_DTO = 'pacs/passage-order-employee-form.dto',
  /** Passage order employee partial update API request body */
  PASSAGE_ORDER_EMPLOYEE_PARTIAL_FORM_DTO = 'pacs/passage-order-employee-partial-form.dto',
  /** Passage order employee find many API query parameters */
  PASSAGE_ORDER_EMPLOYEE_FIND_MANY_QUERY_DTO = 'pacs/passage-order-employee-find-many-query.dto',
  /** Passage order employee find one API query parameters */
  PASSAGE_ORDER_EMPLOYEE_FIND_ONE_QUERY_DTO = 'pacs/passage-order-employee-find-one-query.dto',
  /** Passage order employee find many API response body */
  PASSAGE_ORDER_EMPLOYEE_PAGE_DTO = 'pacs/passage-order-employee-page.dto',
  /** Passage order employee selection settings */
  PASSAGE_ORDER_EMPLOYEE_SELECT_DTO = 'pacs/passage-order-employee-select.dto',
  /** Passage order employee sorting settings */
  PASSAGE_ORDER_EMPLOYEE_SORT_DTO = 'pacs/passage-order-employee-sort.dto',
}
